<ion-header>
  <ion-toolbar>
    <ion-title
      >Add Industry
      {{ parentIndustry ? 'in ' + parentIndustry.name : '' }}</ion-title
    >
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-medium">
    <ion-list>
      <ion-item>
        <ion-label position="stacked">Name</ion-label>
        <ion-input [(ngModel)]="dto.name" (keyup.enter)='create()' [value]='industry?.name'></ion-input>
      </ion-item>
    </ion-list>
    <page-action>
      <super-button [action]="create">Create</super-button>
    </page-action>
  </div>
</ion-content>
